import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoSyncAsifView',
    name: 'MtoSyncAsifView',
    component: () =>
      import('../views/configuracion/syncAsif/SyncAsifView.vue'),
    meta: {
      title: 'SyncASIF',
      roles: getRolesPantalla('MtoUnidadView'),
      requiresAuthentication: true,
      requiresAuthorization: false,
      bread: {
        path: [
          'Configuración',
        ],
      },
    },
  },
];
